import { GridColumn } from "types/grid";
import { Status } from "types/status";
import { CommandingStatusKey } from "./type";

export const COMMANDING_GRID_COLUMNS: GridColumn[] = [
  { title: 'Spacecraft', key: 'linkName', width: 160 },
  { title: 'Ground Station', key: 'contactProfileName', width: 180 },
  { title: 'Available Time', key: 'availableTime', width: 140 },
  { title: 'AOS', key: 'startTime', width: 190 },
  { title: 'LOS', key: 'endTime', width: 190 },
  { title: 'Highest Altitude (Degree)', key: 'maxElevationDegrees', width: 170 },
  { title: 'Commanding', key: 'commandingStatus', width: 160 },
  { title: 'PreScript Status', key: 'preScriptStatus', width: 140 },
  { title: 'Countdown', key: 'countdownLabel', width: 140 }
];

export const COMMANDING_STATUS_MAP: Record<CommandingStatusKey, Status> = {
  PRE_SCRIPT: { title: 'Pre Script', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' },
  LIVE_COMMANDING: { title: 'Live Commanding', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  CONTACT_ENDED: { title: 'Contact Ended', className: 'bg-[#F5F5F5] border-[#B0B0B0] text-[#707070]' },
  UNKNOWN: { title: 'Unknown', className: 'bg-white border-[#B0B0B0] text-[#666666]' }
};